import React from 'react';
import { useTranslator } from '@jutro/locale';
import { MultipleSelect } from '@jutro/components/components/fields/dropdowns/MultipleSelect/MultipleSelect';
import { SelectOption } from '@jutro/components/components/fields/dropdowns/SelectOption/SelectOption'
import messages from './MLPARegisteredOwnersCompnent.messages'
import styles from './MLPARegisteredOwnersCompnent.module.scss'
import { useState, useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';
import appConfig from 'app-config';
function MLPARegisteredOwnersComponent({ drivers, registeredOwnersValue, onChange }) {

    const isQnB = appConfig.portalCode === 'QB';

    const translator = useTranslator();
    const options = useMemo(() =>
        drivers.filter(d => d.type_ML !== 'excluded')
            .map(d => ({
                id: String(d.fixedId),
                label: d.displayFullName_Ext || d.displayName,
                relationship: d.relationshipToInsured_ML,
            })),
        [drivers]
    );

    const pni = useMemo(() => options.find(o => o.relationship === 'self') || null,
        [options]
    );

    useEffect(() => {
        if (!pni) return;
        if (registeredOwnersValue && registeredOwnersValue.length > 0) return;
        onChange && onChange([{ id: pni.id, label: pni.label }]);
    }, [pni, registeredOwnersValue, onChange]);

    const handleChange = (nextValue) => {
        let next = Array.isArray(nextValue) ? nextValue : [];

        next = next.map(v => {
            if (v && typeof v === 'object' && v.id && v.label) {
                return { id: String(v.id), label: v.label };
            }
            const opt = options.find(o => o.id === String(v));
            return opt ? { id: opt.id, label: opt.label } : null;
        }).filter(Boolean);

        if (pni) {
            const rest = next.filter(v => v.id !== pni.id);
            next = [{ id: pni.id, label: pni.label }, ...rest];
        }

        const seen = new Set();
        const uniq = [];
        for (const item of next) {
            if (!seen.has(item.id)) {
                seen.add(item.id);
                uniq.push(item);
            }
        }
        next = uniq.slice(0, 2);
        onChange && onChange(next);
        console.log('Child next selected:', next);
    };

    const limitReached = registeredOwnersValue.length >= 2;

    return (
        <div className={isQnB ? styles.ownerMultiselectQB : styles.ownerMultiselect}>
            <MultipleSelect
                label= {translator(messages.registeredOwnersLabel)}
                placeholder="Select Registered Owner(s)"
                value={registeredOwnersValue}
                onChange={(e, newValue) => handleChange(newValue)}
            >
                {options.map(o => {
                    const isSelf = pni && o.id === pni.id;
                    const isSelected = registeredOwnersValue.some(v => v.id === o.id);
                    return (
                        <SelectOption
                            key={o.id}
                            value={{ id: o.id, label: o.label }}
                            disabled={isSelf || (limitReached && !isSelected)}
                        >
                        </SelectOption>
                    );
                })}
            </MultipleSelect>
        </div>
    );
}

MLPARegisteredOwnersComponent.propTypes = {
    registeredOwners: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
            label: PropTypes.string.isRequired,
        })
    ),
    onOwnerChange: PropTypes.func,
};

MLPARegisteredOwnersComponent.defaultProps = {
    registeredOwners: [],
    onOwnerChange: undefined,
};

export default MLPARegisteredOwnersComponent;